import { render, staticRenderFns } from "./BetgameSwitch.vue?vue&type=template&id=3e6b37c3"
import script from "./BetgameSwitch.vue?vue&type=script&lang=js"
export * from "./BetgameSwitch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports